import React, { useState } from 'react';
import Select from 'react-select';
import AddCharge from '../AddEdit/AddCharge';
import EditCharge from '../AddEdit/EditCharge';

const HBLDtlsTab = () => {
const [showAdd, setShowAdd] = useState(false);
const handleCloseAdd = () => setShowAdd(false);
const handleShowAdd = () => setShowAdd(true);

const [showEdit, setShowEdit] = useState(false);
const handleCloseEdit = () => setShowEdit(false);
const handleShowEdit = () => setShowEdit(true);

return (
<>
<form>
        <div className="row border-bottom-2 pb-3">

        <div className="col-md-6">
                    <label className="form-label">Origin Country</label>
                    <Select className="custom-selector w-100" name="" placeholder="Self" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Pre carriage by</label>
                        <input type="text" className="form-control form-control-sm custom-selector w-100" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Loading pier</label>
                    <Select className="custom-selector w-100" name="" placeholder="Self" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">No of BL Copies</label>
                    <div className="d-flex gap-2">
                        <div className='d-flex'>
                        <label htmlFor=""  className="form-label mt-0">Original</label>
                        <input type="text" className='ms-2 form-control form-control-sm'/>
                        </div>
                        <div className='d-flex'>
                        <label htmlFor="" className="form-label mt-0">Non-Negotiable</label>
                        <input type="text" className='ms-2 form-control form-control-sm' />
                        </div>
                        <div className='d-flex'>
                        <label htmlFor="" className="form-label mt-0">Seaway BLs</label>
                        <input type="text" className='ms-2 form-control form-control-sm' />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Issued At</label>
                        <input type="text" className="form-control form-control-sm custom-selector w-100" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Exporter 's Reference</label>
                        <input type="text" className="form-control form-control-sm custom-selector w-100" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Forwarder 's Reference</label>
                        <input type="text" className="form-control form-control-sm custom-selector w-100" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Freight Payable At</label>
                        <input type="text" className="form-control form-control-sm custom-selector w-100" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">B/L Release Date</label>
                        <input type="date" className="form-control form-control-sm custom-selector w-100" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">SOB Date</label>
                        <input type="date" className="form-control form-control-sm custom-selector w-100" />
                </div>
                <div className="d-flex gap-2 mt-3">
                        <div className='d-flex'>
                        <label htmlFor="" className="form-label">Show Freight</label>
                        <input type="checkbox" className='ms-2'/>
                        </div>
                        <div className='d-flex'>
                        <label htmlFor="" className="form-label">Switch BL</label>
                        <input type="checkbox" className='ms-2' />
                        </div>
                    </div>
                    <div className="col-md-6">
                    <label className="form-label mb-0">HBL Type</label>
                    <div className="d-flex gap-2">
                        <div className='d-flex'>
                        <label htmlFor=""  className="form-label">Shipped on Board</label>
                        <input type="checkbox" className='ms-2'/>
                        </div>
                        <div className='d-flex'>
                        <label htmlFor="" className="form-label">Received for Shipment</label>
                        <input type="checkbox" className='ms-2' />
                        </div>
                    </div>
                </div>
        </div>

    </form>
  

    {showAdd &&
    <AddCharge showAdd={showAdd} handleCloseAdd={handleCloseAdd} />}
    {showEdit &&
    <EditCharge showEdit={showEdit} handleCloseEdit={handleCloseEdit} />}
</>
);
};

export default HBLDtlsTab 